export const company = {
	fields: {
		CNPJ: {
			label: "RFC",
			placeholder: "Ingresar RFC",
		},
		cityCode: {
			label: "Código del municipio",
			placeholder: "Ingresar código del municipio",
		},
		corporateReason: {
			label: "Razón social",
			placeholder: "Ingresar razón social",
		},
		fantasyName: {
			label: "Nombre comercial",
			placeholder: "Ingresar nombre comercial",
		},
		municipalRegistration: {
			label: "Registro municipal",
			placeholder: "Ingresar registro municipal",
		},
		stateRegistration: {
			label: "Registro estatal",
			placeholder: "Ingresar registro estatal",
		},
		taxRegime: {
			label: "Régimen tributario",
			placeholder: "Elija un régimen tributario",
		},
		specialTaxRegime: {
			label: "Régimen especial de tributación",
			placeholder: "Elija un régimen tributario especial",
		},
	},
	optionsTaxation: {
		normalRegime: "Régimen normal",
		simpleNational: "Régimen simplificado",
		simpleNationalExcess: "Régimen simplificado exceso",
	},
	optionsSpecialTaxRegime: {
		cooperativa: "Cooperativa",
		estimativa: "Estimativa",
		meEppSimplesNacional: "PYME - Régimen Simplificado",
		meiSimplesNacional: "Persona Física Empresarial - Régimen Simplificado",
		microempresaMunicipal: "Microempresa municipal",
		sociedadeDeProfissionais: "Sociedad de profesionales",
	},
};
